import { render, staticRenderFns } from "./ContributionGroups.vue?vue&type=template&id=311bb3d1&scoped=true"
import script from "./ContributionGroups.vue?vue&type=script&lang=js"
export * from "./ContributionGroups.vue?vue&type=script&lang=js"
import style0 from "./ContributionGroups.vue?vue&type=style&index=0&id=311bb3d1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311bb3d1",
  null
  
)

export default component.exports